import {useState, useRef} from 'react';

import {Button} from '../../../button/button';
import {MoreOptionsButton} from '../../../button/more-options-button/more-options-button';
import {PaperPlane} from '../../../icon';
import {Stack} from '../../../layout/stack/stack';
import {SelectMenu} from '../../../select-menu/select-menu';

import type {SendInput} from './types';

interface Props {
    onSend: (input?: SendInput | null | undefined) => Promise<any>;
    isSending: boolean;
    isDisabled: boolean;
    showSnoozeOptions?: boolean;
}

export function SendButton(props: Props) {
    const [isViewingPopover, setIsViewingPopover] = useState(false);
    const buttonRef = useRef<HTMLButtonElement | null | undefined>(null);

    const handleSend = (
        input?: {
            snoozeDuration?: number;
            closeThread?: boolean;
        } | null
    ) => {
        setIsViewingPopover(false);
        props.onSend(input);
    };

    if (!props.showSnoozeOptions) {
        return (
            <Button
                variant='primary'
                size='big'
                onClick={() => handleSend()}
                disabled={props.isDisabled}
            >
                <Stack isHorizontal={true} spacing={8} alignItems='center'>
                    <PaperPlane size={14} />
                    {props.isSending ? 'Sending…' : 'Send'}
                </Stack>
            </Button>
        );
    }

    const options = [
        {
            label: 'Send & snooze 1 day',
            handleSelect: () => handleSend({snoozeDuration: 1}),
        },
        {
            label: 'Send & snooze 3 days',
            handleSelect: () => handleSend({snoozeDuration: 3}),
        },
        {
            label: 'Send & snooze 1 week',
            handleSelect: () => handleSend({snoozeDuration: 7}),
        },
        {
            label: 'Send & close',
            handleSelect: () => handleSend({closeThread: true}),
            variant: 'destructive',
        },
    ];

    return (
        <>
            <MoreOptionsButton
                onPrimaryClick={handleSend}
                onSecondaryClick={() => setIsViewingPopover(true)}
                isDisabled={props.isDisabled}
                primaryText={props.isSending ? 'Sending…' : 'Send'}
                getButtonRef={buttonRef}
                primaryIcon={PaperPlane}
            />
            {isViewingPopover && (
                <SelectMenu
                    // @ts-expect-error
                    options={options}
                    anchor={buttonRef.current}
                    location='top-left'
                    onClose={() => setIsViewingPopover(false)}
                />
            )}
        </>
    );
}
